import { styled } from '@volkswagen-onehub/components-core';
import React, { useContext, useEffect } from 'react';
import { PagesContext } from '../store/context/modules/PagesContext';
import { PAGES } from '../types/enums/pages.enum';
import Selections from './Selections';
import Result from './Result';
import { scrollTop } from '../utils/utils';

const PagesContainer = styled.div`
    margin: ${props => props.theme.size.grid001} 0;
`;

export default () => {
    const pagesCtx = useContext(PagesContext);

    useEffect(() => {
        if(!pagesCtx?.value) return;
        scrollTop();
    }, [pagesCtx?.value]);
    return (
        <PagesContainer>
            {pagesCtx?.value == PAGES.SELECTION && <Selections />}
            {pagesCtx?.value == PAGES.RESULT && <Result />}
        </PagesContainer>
    );
}